import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private location = new ReplaySubject<any>();
  private balance = new ReplaySubject<any>();
  private login = new ReplaySubject<any>();
  private apiURL = new ReplaySubject<any>();

  constructor() { }
  
  listen() {
    return this.location.asObservable();
  }

  listenBalance() {
    return this.location.asObservable();
  }

  listenLogin() {
    return this.login.asObservable();
  }
  
  listenApiURL() {
    return this.apiURL.asObservable();
  }

  update(location: string) {
    this.location.next(location);
  }

  updateBalance() {
    this.balance.next({});
  }

  updateLogin() {
    this.login.next({});
  }

  updateApiURL() {
    this.apiURL.next({});
  }
}
